import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoiceMode: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="voice-mode, voice-settings"><path d="M21.25 8.95833V11.0417M17.75 3.75V16.25M14.25 6.875V10.2188M10.75 4.79167V8.91667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><rect x="2.25" y="12.25" width="12" height="8" rx="4" stroke="currentColor" strokeWidth="1.5"/><circle cx="6.25" cy="16.25" r="1.75" fill="currentColor"/></CentralIconBase>;
};

export default IconVoiceMode;
